// TODO - Type 'any' needs to be fixed.
import { Box, Button, Typography } from "@mui/material";
import React from "react";
import { useTranslation } from "react-i18next";

type WorkerTypeFiltersProps = {
	workerTypes: any[];
};

const WorkerTypeFilters = ({ workerTypes }: WorkerTypeFiltersProps) => {
	const { t } = useTranslation();
	const [workerTypeExpand, setWorkerTypeExpand] = React.useState<boolean>(false);

	if (!workerTypes || workerTypes.length === 0) return null;
	return (
		<Box display='flex' flexWrap='wrap' mb={1} alignItems='center'>
			<Typography
				sx={{
					fontWeight: 400,
					fontSize: 14,
					fontFamily: "Roboto",
					color: "#000000",
					marginRight: 1,
				}}
			>
				{t("scheduler_worker-types")} -
			</Typography>
			{workerTypes.length > 0 ? (
				workerTypes
					.slice(0, workerTypeExpand ? undefined : 5)
					.map((type: { name: string; id: number }, index: number) => (
						<Box key={type.id} mr={0.8}>
							<Typography
								sx={{
									fontWeight: 400,
									fontSize: 14,
									fontFamily: "Roboto",
									color: "#000000",
								}}
							>
								{type.name}{index === workerTypes.length - 1 ? "" : ","}
							</Typography>
						</Box>
					))
			) : (
				<></>
			)}
			{workerTypes.length > 5 ? (
				<Button
					onClick={(e) => setWorkerTypeExpand(!workerTypeExpand)}
					size='small'
				>
					{workerTypeExpand ? t("scheduler_show-less") : t("scheduler_show-more")}
				</Button>
			) : null}
		</Box>
	);
};

export default WorkerTypeFilters;
